import { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import Navtoggle from "../Assets/images/nav-toggle.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Link as ScrollLink, scroller } from "react-scroll";
import "../App.css";
import logo from "../Assets/images/Logo.png";
import email from "../Assets/images/email.png";
function Header() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [activeSection, setActiveSection] = useState("home");
  const [menuOpen, setMenuOpen] = useState(false);
  const isActiveRoute = (path) => location.pathname === path;



  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (section) => {
    if (location.pathname !== "/") {
      // If not on homepage, redirect and pass section
      navigate("/", { state: { scrollTo: section } });
    } else {
      // If already on homepage, scroll directly
      scroller.scrollTo(section, {
        smooth: true,
        duration: 500,
        offset: -150,
      });
    }
    setActiveSection(section);
    setShow(false);
  };
  useEffect(() => {
    if (location.pathname !== "/") {
      setActiveSection(""); // 🔹 remove highlight on other routes
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        // Adjust threshold (e.g., 10px)
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);
  return (
    <>
      <div className="head  d-none d-md-flex align-items-center">
        <div className="container d-flex justify-content-between ">
          <p className="mb-0">
            {" "}
            {currentTime.toLocaleString("en-US", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
            })}
          </p>
          <div className="d-flex gap-2">
            <img src={email} alt="" />
            <span style={{ color: "#6d6d6d" }}>support@banksstatements.com</span>
          </div>
        </div>
      </div>
      <div
        className="header"
        style={{ backgroundColor: isScrolled ? "white" : "transparent" }}
      >
        <div className="container">
          <div
            className="row align-items-center  navbar "
            style={{ padding: isScrolled ? "15px 0px" : "10px 0px" }}
          >
        <div className="d-flex justify-content-between align-items-center w-100">
            <div className="logo-container">
              <Link to="/" className="logo-text" >
                <img  onClick={() => handleNavClick("home")}  src={logo} style={{height:"55px"}} alt="Jio Hotstar Game Logo" className="logo-img" />
              </Link>
            </div>

            {/* <div className="d-none d-lg-flex align-items-center">
             <ul className="d-flex  align-items-center justify-content-center m-0 p-0 nav-item">
                <li
                  onClick={() => {
                    navigate("/");
                    handleNavClick("home");
                  }}
                  className={activeSection === "home" ? "active" : ""}
                >
                  Home
                </li>
                <li
                  onClick={() => handleNavClick("type")}
                  className={activeSection === "type" ? "active" : ""}
                >
                  Bank Type
                </li>
                <li
                  onClick={() => handleNavClick("core-banking")}
                  className={activeSection === "core-banking" ? "active" : ""}
                >
                  Services
                </li>
                <li
                  onClick={() => handleNavClick("account-type")}
                  className={activeSection === "account-type" ? "active" : ""}
                >
                  Account
                </li>
                <li
                  onClick={() => handleNavClick("loan")}
                  className={activeSection === "loan" ? "active" : ""}
                >
                  Loans
                </li>
                <li
                  onClick={() => handleNavClick("investment")}
                  className={activeSection === "investment" ? "active" : ""}
                >
                  Investment
                </li>
                <li
                  onClick={() => handleNavClick("digital-banking")}
                  className={
                    activeSection === "digital-banking" ? "active" : ""
                  }
                >
                  Digital Banking
                </li>
              </ul>
            </div> */}
            <div className="d-none d-lg-flex align-items-center">
            <ul className="d-flex  align-items-center justify-content-center m-0 p-0 nav-item">
            <li
            className="home-dropdown li"
            onMouseEnter={() => setMenuOpen(true)}
            onMouseLeave={() => setMenuOpen(false)}
            >
            <span
            onClick={() => {
            navigate("/");
            handleNavClick("home");
            setMenuOpen(false);
            }}
            className={activeSection === "home" ? "active" : ""}
            >
            Home
            </span>

            {menuOpen && (
            <div className="dropdown-box">
            <ul>
              <li
                onClick={() => {
                  handleNavClick("type");
                  setMenuOpen(false);
                }}
              >
                Bank Type
              </li>

              <li
                onClick={() => {
                  handleNavClick("core-banking");
                  setMenuOpen(false);
                }}
              >
                Services
              </li>

              <li
                onClick={() => {
                  handleNavClick("account-type");
                  setMenuOpen(false);
                }}
              >
                Account
              </li>

              <li
                onClick={() => {
                  handleNavClick("loan");
                  setMenuOpen(false);
                }}
              >
                Loans
              </li>

              <li
                onClick={() => {
                  handleNavClick("investment");
                  setMenuOpen(false);
                }}
              >
                Investment
              </li>

              <li
                onClick={() => {
                  handleNavClick("digital-banking");
                  setMenuOpen(false);
                }}
              >
                Digital Banking
              </li>
            </ul>
            </div>
            )}
            </li>
            <li className="li">
               <span
            onClick={() => {
            navigate("/about");
            setMenuOpen(false);
            }}
            className={isActiveRoute("/about") ? "active" : ""}
            >
            About Us
            </span>
            </li>
             <li className="li">
               <span
            onClick={() => {
            navigate("/blogs");
            setMenuOpen(false);
            }}
            className={isActiveRoute("/blogs") ? "active" : ""}
            >
            Blogs
            </span>
            </li>

             <li className="li">
               <span
            onClick={() => {
            navigate("/contact");
            setMenuOpen(false);
            }}
            className={isActiveRoute("/contact") ? "active" : ""}
            >
            Contact Us
            </span>
            </li>

             <li className="li">
               <span
            onClick={() => {
            navigate("/privacypolicy");
            setMenuOpen(false);
            }}
            className={isActiveRoute("/privacypolicy") ? "active" : ""}
            >
            Privacy Policy
            </span>
            </li>

              <li className="li">
               <span
            onClick={() => {
            navigate("/termsofuse");
            setMenuOpen(false);
            }}
            className={isActiveRoute("/termsofuse") ? "active" : ""}
            >
           Terms of Use
            </span>
            </li>
            </ul>
            </div>

            <div className=" col-md-1 d-lg-none d-flex flex-column navbar">
              <img
                src={Navtoggle}
                alt="Menu Icon"
                onClick={handleShow}
                style={{ cursor: "pointer", height: "25px" }}
              />
            </div>
          </div>

            {/* <div className="col-2 col-md-1 d-lg-none d-flex flex-column  navbar">
              <img
                src={Navtoggle}
                alt="Menu Icon"
                onClick={handleShow}
                style={{ cursor: "pointer", height: "25px" }}
              />
            </div> */}

            <Offcanvas show={show} onHide={handleClose}>
              <Offcanvas.Header closeButton>
                <Offcanvas.Title></Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                {/* <ul className="d-flex flex-column gap-4 justify-content-center m-0 p-0 nav-item">
                  <li
                    onClick={() => {
                      navigate("/");
                      handleClose();
                    }}
                    className={activeSection === "home" ? "active" : ""}
                  >
                    Home
                  </li>
                  <li
                    onClick={() => handleNavClick("type")}
                    className={activeSection === "type" ? "active" : ""}
                  >
                    Bank Type
                  </li>
                  <li
                    onClick={() => handleNavClick("core-banking")}
                    className={activeSection === "core-banking" ? "active" : ""}
                  >
                    Services
                  </li>
                  <li
                    onClick={() => handleNavClick("account-type")}
                    className={activeSection === "account-type" ? "active" : ""}
                  >
                    Account
                  </li>
                  <li
                    onClick={() => handleNavClick("loan")}
                    className={activeSection === "loan" ? "active" : ""}
                  >
                    Loans
                  </li>
                  <li
                    onClick={() => handleNavClick("investment")}
                    className={activeSection === "investment" ? "active" : ""}
                  >
                    Investment
                  </li>
                  <li
                    onClick={() => handleNavClick("digital-banking")}
                    className={
                      activeSection === "digital-banking" ? "active" : ""
                    }
                  >
                    Digital Banking
                  </li>
                </ul> */}
            <ul className="d-flex flex-column gap-4 justify-content-center m-0 p-0 nav-item">
            {/* <li
            className="home-dropdown li"
            onMouseEnter={() => setMenuOpen(true)}
            onMouseLeave={() => setMenuOpen(false)}
            >
            <span
            onClick={() => {
            navigate("/");
            handleClose();
            setMenuOpen(false);
            }}
            className={activeSection === "home" ? "active" : ""}
            >
            Home
            </span>

            {menuOpen && (
            <div className="dropdown-box">
            <ul>
              <li
                onClick={() => {
                  handleNavClick("type");
                  setMenuOpen(false);
                   handleClose();
                }}
                className={activeSection === "type" ? "active" : ""}
                
              >
                Bank Type
              </li>

              <li
                onClick={() => {
                  handleNavClick("core-banking");
                  setMenuOpen(false);
                   handleClose();
                }}
                 className={activeSection === "core-banking" ? "active" : ""}
              >
                Services
              </li>

              <li
                onClick={() => {
                  handleNavClick("account-type");
                  setMenuOpen(false);
                   handleClose();
                }}
                 className={activeSection === "account-type" ? "active" : ""}
              >
                Account
              </li>

              <li
                onClick={() => {
                  handleNavClick("loan");
                  setMenuOpen(false);
                   handleClose();
                }}
                 className={activeSection === "loan" ? "active" : ""}
              >
                Loans
              </li>

              <li
                onClick={() => {
                  handleNavClick("investment");
                  setMenuOpen(false);
                   handleClose();
                }}
                className={activeSection === "investment" ? "active" : ""}
              >
                Investment
              </li>

              <li
                onClick={() => {
                  handleNavClick("digital-banking");
                  setMenuOpen(false);
                   handleClose();
                }}
                className={
                      activeSection === "digital-banking" ? "active" : ""
                    }
              >
                Digital Banking
              </li>
            </ul>
            </div>
            )}
            </li> */}
                  <li className="home-dropdown li">
              {/* HOME = only dropdown toggle */}
              <span
              onClick={() => setMenuOpen(!menuOpen)}
              className={activeSection === "home" ? "active" : ""}
              >
              Home
              </span>

              {menuOpen && (
              <div className="dropdown-box">
              <ul>
              {/* 👉 Homepage redirect option */}
              <li
                // onClick={() => {
                //   navigate("/");
                //   setMenuOpen(false);
                //   handleClose();
                // }}
                onClick={() => {
                if (location.pathname === "/") {
                // 🔹 already on homepage → scroll to top
                scroller.scrollTo("home", {
                smooth: true,
                duration: 500,
                offset: -150,
                });
                } else {
                // 🔹 not on homepage → navigate & then scroll
                navigate("/", { state: { scrollTo: "home" } });
                }

                setActiveSection("home"); // 🔹 highlight fix
                setMenuOpen(false);
                handleClose();
                }}
              >
                Home 
              </li>

              <li
                onClick={() => {
                  handleNavClick("type");
                  setMenuOpen(false);
                  handleClose();
                }}
                className={activeSection === "type" ? "active" : ""}
              >
                Bank Type
              </li>

              <li
                onClick={() => {
                  handleNavClick("core-banking");
                  setMenuOpen(false);
                  handleClose();
                }}
                className={activeSection === "core-banking" ? "active" : ""}
              >
                Services
              </li>

              <li
                onClick={() => {
                  handleNavClick("account-type");
                  setMenuOpen(false);
                  handleClose();
                }}
                className={activeSection === "account-type" ? "active" : ""}
              >
                Account
              </li>

              <li
                onClick={() => {
                  handleNavClick("loan");
                  setMenuOpen(false);
                  handleClose();
                }}
                className={activeSection === "loan" ? "active" : ""}
              >
                Loans
              </li>

              <li
                onClick={() => {
                  handleNavClick("investment");
                  setMenuOpen(false);
                  handleClose();
                }}
                className={activeSection === "investment" ? "active" : ""}
              >
                Investment
              </li>

              <li
                onClick={() => {
                  handleNavClick("digital-banking");
                  setMenuOpen(false);
                  handleClose();
                }}
                className={activeSection === "digital-banking" ? "active" : ""}
              >
                Digital Banking
              </li>
              </ul>
              </div>
              )}
              </li>

            <li className="li">
               <span
            onClick={() => {
            navigate("/about");
            setMenuOpen(false);
             handleClose();
            }}
           className={isActiveRoute("/about") ? "active" : ""}
            >
            About Us
            </span>
            </li>
             <li className="li">
               <span
            onClick={() => {
            navigate("/blogs");
            setMenuOpen(false);
             handleClose();
            }}
            className={isActiveRoute("/blogs") ? "active" : ""}
            >
            Blogs
            </span>
            </li>

             <li className="li">
               <span
            onClick={() => {
            navigate("/contact");
            setMenuOpen(false);
             handleClose();
            }}
            className={isActiveRoute("/contact") ? "active" : ""}
            >
            Contact Us
            </span>
            </li>

             <li className="li">
               <span
            onClick={() => {
            navigate("/privacypolicy");
            setMenuOpen(false);
             handleClose();
            }}
            className={isActiveRoute("/privacypolicy") ? "active" : ""}
            >
            Privacy Policy
            </span>
            </li>

              <li className="li">
               <span
            onClick={() => {
            navigate("/termsofuse");
            setMenuOpen(false);
             handleClose();
            }}
            className={isActiveRoute("/termsofuse") ? "active" : ""}
            >
           Terms of Use
            </span>
            </li>
            </ul>
              </Offcanvas.Body>
            </Offcanvas>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
